import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  LOAN_DETAIL_CHANGED,
  UPDATE_COMMITMENTS_SUCCESS,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_LOAN_DETAIL_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
} from '../../actions/types'

const INIT_STATE = {
  fixedRepaymentType: 'principal_and_interest',
  fixedInterestPeriod: '1',
}

const prefilledState = (newState, defaultAmount) => {
  const fixedAmount = newState.fixedAmount || defaultAmount
  const fixedRepaymentType = newState.fixedRepaymentType || INIT_STATE.fixedRepaymentType
  const fixedInterestPeriod = newState.fixedInterestPeriod || INIT_STATE.fixedInterestPeriod

  return {
    fixedAmount,
    fixedRepaymentType,
    fixedInterestPeriod,
  }
}

const fixedRate = (state = INIT_STATE, {type, payload}) => {
  switch (type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      if (payload.applicationFlow.loanDetail !== undefined ) {
        const defaultAmount = payload.applicationFlow.loanApplication.loanAmount
        const newState = payload.applicationFlow.loanDetail.fixed

        return prefilledState(newState, defaultAmount)
      } else {
        return state
      }

    case UPDATE_COMMITMENTS_SUCCESS:
    case UPDATE_ASSETS_SUCCESS:
    case UPDATE_LOAN_DETAIL_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      if (payload.loanDetail !== undefined) {
        const defaultAmount = payload.loanApplication.loanAmount
        const newState = payload.loanDetail.fixed

        return prefilledState(newState, defaultAmount)
      } else {
        return state
      }

    case LOAN_DETAIL_CHANGED:
      return { ...state, ...payload.fixed }
    default:
      return state;
  }
}

export default fixedRate;
